import {makeAutoObservable} from "mobx"

class AppStore {
   assetSignledata = null
   customAttrModal = false

   constructor () {
      makeAutoObservable(this)
   }
   setAssetSignledata = (data) => (this.assetSignledata = data)
   setCustomAttrModal = (data) => (this.customAttrModal = data)
}

export default new AppStore()